import React from "react";
import PropTypes from "prop-types";
import { withNamespaces } from "react-i18next";
import classNames from "classnames";
import { getSnowTypes } from "../../SnowTypes";

const SnowType = props => {
  return (
    <a
      href={"#snowType" + props.id}
      role="button"
      className={classNames("snow-type-item", props.selected ? "selected" : {})}
      onClick={event => {
        event.preventDefault();
        props.onSelect(props.id);
      }}
    >
      <div className="inside-wrap">
        <div className="image">
          <i className={props.icon} />
        </div>
        <span className={classNames("label", props.selected ? "selected" : {})}>
          {props.name}
        </span>
      </div>
    </a>
  );
};

const SnowParameter = props => {
  return (
    <div className="parameter-container">
      <div className="wrap">
        <div className="param-header">
          <div className="param-title">{props.title}</div>
          <div className="param-value" />
        </div>
        <div className="param-content snow-types">
          {getSnowTypes().map((snowType, index) => {
            return (
              <SnowType
                key={snowType.id}
                {...snowType}
                name={props.t("parameters:snow_types." + snowType.id)}
                index={index}
                selected={props.value === snowType.id}
                onSelect={props.onValueChange}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

SnowParameter.propTypes = {
  title: PropTypes.string,
  value: PropTypes.number,
  onValueChange: PropTypes.func
};

SnowParameter.defaultProps = {
  title: "Snowtype",
  value: null,
  onValueChange: () => {}
};

export default withNamespaces(["parameters", "common"], { wait: true })(SnowParameter);
